export class TransportError extends Error {
    constructor(status, url, error) {
        super();
        this.status = status;
        this.url = url;
        this.error = error;
        this.name = this.constructor.name;
    }
}
//# sourceMappingURL=transport-error.js.map